/**
 * Returns an array of regex matches.
 *
 * @export
 * @param {any} regex The regular expression to run.
 * @param {any} string The string to search.
 * @returns An array of matches.
 */
export function matches (regex, string) {
  let matches = []
  let match = regex.match(string)

  while (match) {
    const location = match.index
    const length = location + match[0].length

    matches.push({
      location: localStorage,
      length: length,
      substring: string.substr(location, length),
    })
    match = regex.match(string)
  }

  return matches
}

/*
  This matches `1st`, `2nd`, `89th`, etc.
*/
export const regex = {

  // The floor number in a building.
  FLOOR_NUMBER: /^[1-9]+((st) | (nd) | (rd) | (th))/,

  // A trailing number
  TRAILING_NUMBER: /[0-9]+$/,

  // The entirety blocks of an IPv4 Address
  IPv4_ADDRESS: /(([0-9]{1,3})\.){3}[0-9]{1,3}/g,

  // The port segment of a URL.
  PORT: /:[0-9]{1,4}/,

  // The hikvision channel
  HIKVISION_CHANNEL: /(\/[0-9]+)$/,

  // Basic regex. I tested this in regexr to work against hex strings with 8-4-4-4-12 patterns.
  // See https://regexr.com/3hkvj
  UUID: /([0-9a-f]){8}-((([0-9a-f]){4}-){3})([0-9a-f]){12}/,
}
